<template>
    <b-modal :active.sync="isOrderOverViewModalActive"
             style="width: auto"
             has-modal-card :can-cancel="false">
        <div id="order-overview-component" class="modal-card" style="width: auto; overflow: initial">
            <header class="modal-card-head">
                <div class="modal-card-title overflow-text">Order: {{orderInfo.reference}}</div>

              <button class="button"  @click="$emit('close')"><span><b-icon pack="fa" icon="times" size="is-small"/></span></button>

            </header>
            <section class="modal-card-body">
                <template>
                    <div class="order-overview-box">
                        <b-tabs type="is-boxed">
                            <b-tab-item label="General" icon="info">
                                <order-general :orderInfo="orderInfo"></order-general>
                            </b-tab-item>
                            <b-tab-item label="Items" icon="shopping-cart">
                                <order-items :orderInfo="orderInfo"></order-items>
                            </b-tab-item>
                            <b-tab-item label="Addresses" icon="address-book">
                                <order-addresses :orderInfo="orderInfo"></order-addresses>
                            </b-tab-item>
                        </b-tabs>
                    </div>
                </template>
            </section>
            <footer class="modal-card-foot is-pulled-right has-text-right is-block">
              <actions-list :orderInfo="orderInfo"/>
            </footer>
        </div>
    </b-modal>
</template>

<script>
import OrderGeneral from './OrderGeneral'
import OrderAddresses from './OrderAddresses'
import OrderItems from './OrderItems'
import ActionsList from '@/components/order-owerview/ActionsList'

export default {
  components: { ActionsList, OrderItems, OrderAddresses, OrderGeneral },
  props: {
    isOrderOverViewModalActive: Boolean,
    orderInfo: Object
  },
  data () {
    return {
      data: [],
      query: '',
      selected: null
    }
  }
}
</script>
